// extracted by mini-css-extract-plugin
export default {"category":"WHbHV","heading":"_4yMIn","items":"Ddj-V","item":"xYy1L","button":"_29gHG","subheading":"pyb0w","bullet":"gG2KV"};